'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

var _TreeNode = require('./TreeNode');

var _TreeNode2 = _interopRequireDefault(_TreeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// export this package's api
_Select2["default"].TreeNode = _TreeNode2["default"];
exports["default"] = _Select2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.9.3@rc-tree-select/lib/index.js
 ** module id = 431
 ** module chunks = 0 1
 **/